export default __webpack_public_path__ + "static/media/apache.2c992ddb.png";